import jss from "json-stable-stringify";
import md5 from "md5";

import type { ConstructedDeliverable } from "@/types/types";
import type { ComputedDeliverable } from "hoxton-types";

import type { LanguageCode } from "@/utils/languages";

type DeliverableIdentity = {
    language: LanguageCode;
    masterTemplateId: string | null | undefined;
    editableGroupValueIds: string[];
};

export function getIdHash(deliverableIdentity: DeliverableIdentity) {
    return md5(getIdHashOpen(deliverableIdentity)!);
}

export function getIdHashOpen(deliverableIdentity: DeliverableIdentity) {
    const sortedIdentity = ({ editableGroupValueIds, ...identity }: DeliverableIdentity) => ({
        editableGroupValueIds: editableGroupValueIds.sort(),
        ...identity
    });
    return jss(sortedIdentity(deliverableIdentity));
}

export function getIdHashFromObject(deliverable: ComputedDeliverable) {
    const deliverableIdentity = getDeliverableIdentityFromObject(deliverable);
    return getIdHash(deliverableIdentity);
}

export function getIdHashOpenFromObject(deliverable: ComputedDeliverable) {
    const deliverableIdentity = getDeliverableIdentityFromObject(deliverable);
    return getIdHashOpen(deliverableIdentity);
}

export function getDeliverableIdentityFromObject(deliverable: ComputedDeliverable | ConstructedDeliverable) {
    return {
        language: deliverable.language,
        masterTemplateId: "masterTemplateId" in deliverable ? deliverable.masterTemplateId : undefined,
        editableGroupValueIds: deliverable.editableGroupValueIds
    } as DeliverableIdentity;
}
